import { saleSendEmailMessage, saleSendSmsMessage } from '~/apps/pos/apis/message';

export type Options = {
  saleId: string,
  email: string,
  phone: string,
  cb: any,
};

export function sendMessageEmail(options: Options) {
  const { saleId, email, cb } = options;

  saleSendEmailMessage(saleId, { email })
    .then((result) => {
      if (cb) {
        if (result.hasOwnProperty('error_code') && result.error_code === 0) {
          cb({
            ...result,
            isError: false,
            message: 'An email was sent successfully.',
          })
        } else {
          cb({
            ...result,
            isError: true
          })
        }
      }
    })
    .catch((err) => {
      if (cb) {
        cb({
          ...err,
          isError: true
        })
      }
    });
}

export function sendMessageSMS(options: Options) {
  const { saleId, phone, cb } = options;

  saleSendSmsMessage(saleId, { phone })
    .then((result) => {
      if (cb) {
        if (result.hasOwnProperty('Sid') && result.Sid) {
          cb({
            ...result,
            isError: false,
            message: 'A text message was sent successfully.',
          })
        } else {
          cb({
            ...result,
            isError: true
          })
        }
      }
    })
    .catch((err) => {
      if (cb) {
        cb({
          ...err,
          isError: true
        })
      }
    });
}
